import { Injectable } from '@angular/core';
import flagsmith from '@flagsmith/flagsmith';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FlagSmithService {
 private flagsSubject = new BehaviorSubject<any>({});
  public flags$ = this.flagsSubject.asObservable();

  constructor() {}

  // Initialise Flagsmith avec l'ID de l'environnement (dev/prod)
  init() {
    flagsmith.init({
      environmentID: environment.flagsmithEnvId,
      cacheFlags: true,
      enableAnalytics: true,
      onChange: this.onFlagsChanged
    });
  }

  private onFlagsChanged = (oldFlags: any, params: any) => {
    const allFlags = flagsmith.getAllFlags();
    this.flagsSubject.next(allFlags); // met à jour l'observable
  };

  isEnabled(flag: string): boolean {
    return flagsmith.hasFeature(flag);
  }

  getValue(flag: string): any {
    return flagsmith.getValue(flag);
  }
}